import placeholder_url, { is_placeholder_url, placeholder_params, placeholder_aspect } from '../../../placeholder';

const Component = ({ w, h }) => <UI.Picture source={ placeholder_url(w, h) } />

Component.is = (url) => is_placeholder_url(url)
Component.aspect = (img, aspectRatio) => placeholder_aspect(img, aspectRatio)

export default Component
